import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../lib/firebase';
const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);
export function AuthProvider({ children }) {
    const [state, setState] = useState({ user: null, userData: null, loading: true, error: null });
    useEffect(() => {
        let revision = 0;
        const unsubscribe = onAuthStateChanged(auth, async user => {
            const current = ++revision;
            setState({ user, userData: null, loading: true, error: null });
            try {
                const profile = user ? await getDoc(doc(db, 'users', user.uid)) : null;
                if (current !== revision) return;
                setState({ user, userData: profile?.exists() ? profile.data() : null, loading: false,
                    error: user && !profile?.exists() ? 'Your student profile is not available. Please contact your administrator.' : null });
            } catch (error) {
                if (current === revision) setState({ user, userData: null, loading: false, error: 'We could not load your profile. Check your connection and try again.' });
            }
        }, () => setState({ user: null, userData: null, loading: false, error: 'Unable to connect to sign-in. Please reload.' }));
        return () => { revision++; unsubscribe(); };
    }, []);
    return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
}
